import { getRateName } from '@mews-commander/legacy-entities/src/ducks/rates';
import { useCommanderSelector } from '@mews-commander/utils';

interface RateNameProps {
    rateId: string;
}

export const RateName = ({ rateId }: RateNameProps) => {
    const rateName = useCommanderSelector((state) => getRateName(state, { rateId }));
    return <span data-test-id="rateName">{rateName}</span>;
};
